import moment from "moment";

import 'moment/locale/de';  // For German locale
moment.locale('de')

export function formatTimeFromDateTime(dateTime) {
    if (dateTime) {
        return moment(dateTime).format("HH:mm")
    }
    return ""
}

export function formatDateTime(dateTime) {
    return moment(dateTime).format("DD.MM.yyyy HH:mm")
}

export function formatDate(date) {
    if (!date) return ""
    return moment(date).format("DD.MM.yyyy")
}

export function formatDateWithWeekday(date) {
    if (!date) return ""
    return moment(date).format("dd DD.MM.yyyy")
}

export function formatCurrency(number, decimalPlaces = 2) {
    var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: decimalPlaces
    });
    return formatter.format(number)
}